import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Icon from './Icon'

class Sherlock extends Component {
  render() {
    return (
      <Icon {...this.props}>
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width={this.props.width}
          height={this.props.height}
          viewBox="0 0 558.000000 436.000000"
          preserveAspectRatio="xMidYMid meet">
          <metadata>
            Created by potrace 1.16, written by Peter Selinger 2001-2019
          </metadata>
          <g
            transform="translate(0.000000,436.000000) scale(0.100000,-0.100000)"
            fill={this.props.fill}
            stroke="none">
            <path
              d="M1192 4187 l-172 -172 0 -883 0 -882 1760 0 1760 0 0 883 0 882 -173
173 -172 172 -1415 0 -1415 0 -173 -173z"
            />
            <path
              d="M665 2083 c-283 -35 -491 -103 -590 -194 -57 -53 -75 -86 -75 -139 0
-53 18 -86 75 -139 82 -76 249 -139 465 -177 100 -18 207 -19 2250 -19 2043 0
2150 1 2250 19 216 38 383 101 465 177 57 53 75 86 75 139 0 53 -18 86 -75
139 -78 72 -236 134 -455 178 -78 16 -249 17 -2220 19 -1174 0 -2148 0 -2165
-3z"
            />
            <path
              d="M1475 1231 c-174 -50 -311 -163 -391 -323 -45 -89 -64 -173 -64 -283
0 -110 19 -194 64 -283 109 -216 314 -342 556 -342 242 0 447 126 556 343 50
98 66 181 62 312 l-3 110 70 9 c93 11 742 13 876 3 l105 -9 -4 -111 c-5 -133
11 -214 62 -314 109 -217 314 -343 556 -343 242 0 447 126 556 342 45 89 64
173 64 283 0 110 -19 194 -64 283 -109 216 -314 342 -556 342 -145 0 -269 -42
-383 -128 -51 -39 -132 -131 -150 -171 -10 -21 -15 -23 -62 -17 -265 34 -348
38 -625 32 -177 -3 -321 -11 -380 -20 -127 -20 -135 -20 -147 7 -18 38 -100
130 -150 169 -64 49 -154 93 -230 112 -82 21 -239 20 -318 -3z"
            />
          </g>
        </svg>
      </Icon>
    )
  }
}

Sherlock.defaultProps = {
  fill: '#FFFFFF',
  width: 30,
  height: 30
}

Sherlock.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
}

export default Sherlock
